import useGeoLocation from '@api/hooks/useGeoLocation';
import constants from '@cont/Login/constants';
import useLoginStore from '@stores/login/loginStore';
import { getOTPSender } from '@stores/selectors/login';
import { useCallback } from 'react';
import useIsOutsideIndiaFlow from './useIsOutsideIndiaFlow';

const useResendOTP = ({
  setOtpStepError,
  country,
  loginType,
  mobileNumber,
  email,
  sourceType,
  logOTPRequestedEvent
}) => {
  const isOutsideIndiaFlow = useIsOutsideIndiaFlow();
  const { geoLocationData: { countryCode } = {} } = useGeoLocation();

  const sendOtpOrEmail = useLoginStore(getOTPSender);

  return useCallback(
    (otp_type) => {
      setOtpStepError(null);
      const countryCodeToSend = isOutsideIndiaFlow
        ? countryCode || country?.code
        : country?.code || countryCode;
      sendOtpOrEmail({
        phone: mobileNumber,
        countryCode: countryCodeToSend,
        otpType: otp_type,
        email: loginType === constants.LOGIN_TYPE_EMAIL ? email : ''
      }).then((result) => {
        if (!sourceType) logOTPRequestedEvent(result);
      });
    },
    [
      country?.code,
      countryCode,
      sendOtpOrEmail,
      email,
      isOutsideIndiaFlow,
      logOTPRequestedEvent,
      loginType,
      mobileNumber,
      setOtpStepError,
      sourceType
    ]
  );
};

export default useResendOTP;
